//components
import { Button, Container, NavigationBar, Page } from "./styles";

//assets
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const MenuMobile = () => {
  const [showMenu, setShowMenu] = useState<boolean>(true);
  const [pathName, setPathName] = useState(window.location.pathname);

  const { pathname } = useLocation();
  const handleShowMenu = () => {
    setTimeout(() => setShowMenu(!showMenu), 150);
  };
  useEffect(() => {
    setPathName(pathname);
    setShowMenu(true);
  }, [pathname]);

  return (
    <Container>
      {!showMenu ? (
        pathname === "/" || pathname === "/about_us" ? (
          <NavigationBar>
            <Button onClick={handleShowMenu} className="show"></Button>
            <Page to="/" className={pathName === "/" ? "login" : ""}>
              Login
            </Page>
            <Page
              to="/about_us"
              className={pathName === "/about_us" ? "about_us" : ""}
            >
              Sobre nós
            </Page>
          </NavigationBar>
        ) : (
          <NavigationBar>
            <Button onClick={handleShowMenu} className="show"></Button>
            <Page
              to="/unitHabits"
              className={pathName === "/unitHabits" ? "unitHabits" : ""}
            >
              UH's
            </Page>
            <Page
              to="/guests"
              className={pathName === "/guests" ? "guests" : ""}
            >
              Hóspedes
            </Page>
            <Page
              to="/products_services"
              className={
                pathName === "/products_services" ? "products_services" : ""
              }
            >
              Produtos e Serviços
            </Page>
            <Page
              to="/colaborators"
              className={pathName === "/colaborators" ? "colaborators" : ""}
            >
              Colab
            </Page>
            <Page
              to="/dashboard"
              className={pathName === "/dashboard" ? "dashboard" : ""}
            >
              Home
            </Page>
          </NavigationBar>
        )
      ) : (
        <NavigationBar>
          <Button onClick={handleShowMenu}></Button>
        </NavigationBar>
      )}
    </Container>
  );
};

export default MenuMobile;
